// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_t7f","cls2":"download_preflight-cls2_FXt download_preflight-cls1_t7f"};